import { defineStore } from 'pinia';
interface CustomerState {
  user: null,
  token: null,
  isLoggedIn: boolean,
  isSetToken: boolean,
  LoginPath: null,
  prePayNum: number,
  isGoPay: boolean,
  settlement: number
}

export const useCustomerStore = defineStore('customer', {
  state: (): CustomerState => ({
    user: null,
    token: null,
    isLoggedIn: false,
    isSetToken: false,
    LoginPath: null,
    prePayNum: 0,
    isGoPay: false,
    settlement: 0
  }),
  actions: {
    setIsLoggedIn(isLoggedIn: boolean) {
      this.isLoggedIn = isLoggedIn;
    },
    setToken(token: string) {
      this.token = token;
    },
    setUser(user: any) {
      this.user = user;
    },
    async setisSetToken(status: boolean) {
      this.isSetToken = status;
    },
    setLoginPath(path: string) {
      this.LoginPath = path;
    },
    setPrePayNum(num: number) {
      if (num > 0 && num !== undefined) {
        this.prePayNum = num;
      } else {
        this.prePayNum = 0;
      }
    },
    setSettlement(settlement: number) {
      this.settlement = settlement;
    },
    setIsGoPay(status: boolean) {
      this.isGoPay = status;
    },
    celarAll() {
      this.user = null,
      this.token = null,
      this.isLoggedIn = false,
      this.isSetToken = false,
      this.LoginPath = null,
      this.prePayNum = 0,
      this.isGoPay = false;
    }
  },
  persist: {
    enabled: true,
    strategies: [
      // { storage: sessionStorage, paths: ['firstName', 'lastName'] },
      { key: 'customer' }
    ]
  }
});
